/* DSL Best-discount finder — try multiple codes, pick the largest discount */
(function(){
  document.addEventListener("click", function(e){
    if (!e.target.matches("[data-best-discount-finder]")) return;
    var codes = (e.target.dataset.bestDiscountFinder || "WELCOME10,WELCOME15,SUMMER20,SAVE5").split(",");
    var totals = {};
    Promise.all(codes.map(function(code){
      return fetch("/discount/" + encodeURIComponent(code.trim()), {redirect: "manual"}).then(function(){
        return fetch("/cart.js").then(function(r){return r.json();}).then(function(c){
          totals[code] = c.total_price;
        });
      }).catch(function(){});
    })).then(function(){
      var best = Object.keys(totals).reduce(function(a, b){ return totals[a] < totals[b] ? a : b; });
      if (window.DSL_BANNER) window.DSL_BANNER.show({text: "Beste code: " + best + " (€" + ((Math.max.apply(null, Object.values(totals)) - totals[best])/100).toFixed(2) + " bespaard)", variant: "success"});
    });
  });
})();